<template>
    <header class="top-bar" tabindex="-1">
        <div class="top-bar-logo-td">
            <button v-if="!isNotFoundPage" type="button" class="top-bar-button" :aria-label="$t('Open/Close Main menu')" :title="$t('Open/Close Main menu')" @click="clickMenu">
                <i class="fas fa-bars"></i>
            </button>
            <router-link to="/">
                <picture>
                    <source srcset="/img/logo.webp" type="image/webp">
                    <img class="logo-img" src="/img/logo.svg" width="255" height="74" :alt="$t('Salus logo')">
                </picture>
            </router-link>
        </div>

        <div class="inner-top-bar">
            <div class="top-bar-user-td" v-if="loggedIn">
                <span class="top-bar-hello-message">{{ $t("Hello, $USER!").replace("$USER", renderName(profileName)) }}</span>
                <button type="button" class="top-bar-button-img" :title="$t('User settings')" :aria-label="$t('User settings')" @click="openUserSettings">
                    <ProfileImage :url="profileImage"/>
                </button>
            </div>

            <div class="top-bar-user-td" v-if="!loggedIn">
                <button type="button" class="top-bar-button" :title="$t('Select your language')" @click="selectLanguage">
                    <i class="fas fa-language"></i>
                </button>
                <button type="button" class="top-bar-button" :title="$t('Change theme')" @click="invertTheme">
                    <i v-if="theme === 'dark'" class="fas fa-sun"></i>
                    <i v-else class="fas fa-moon"></i>
                </button>
                <button type="button" @click="login" class="btn btn-primary btn-top-bar-login" :aria-label="$t('Login')">
                    <i class="fas fa-sign-in"></i>
                </button>
            </div>

            <div class="top-bar-notifications" v-if="$route.path !== '/notifications'">
                <button type="button" @click="showNotifications" class="btn btn-primary btn-top-bar-notifictions" :aria-label="$t('Notifications')">
                    <i class="fas fa-bell"></i>
                    <span class="num-notifications">{{ unreadCount }}</span>
                </button>
            </div>
        </div>
    </header>
</template>

<script lang="ts">
import { ColorThemeName, getTheme, setTheme } from "@/control/app-preferences";
import { AuthController } from "@/control/auth";
import { defineComponent } from "vue";
import ProfileImage from "@/components/utils/ProfileImage.vue";

export default defineComponent({
    components: { ProfileImage },
    name: "TopBar",
    emits: ["toggle-menu", "openModal", 'toggle-notifications-menu'],
    props: {
        unreadCount: Number,
    },
    data: function () {
        return {
            platformName: import.meta.env.VITE__PLATFORM_NAME || "Salus",
            loggedIn: AuthController.isAuthenticated(),
            profileImage: AuthController.ProfileImage,
            theme: getTheme(),
            profileName: AuthController.ProfileName || AuthController.Username || "",
        };
    },
    computed: {
        isNotFoundPage(): boolean {
            return this.$route.name === "not-found";
        }
    },
    methods: {
        openUserSettings: function () {
            this.$emit("openModal", "account-settings");
        },

        selectLanguage: function () {
            this.$emit("openModal", "change-language-modal");
        },

        invertTheme: function () {
            setTheme(this.theme === "dark" ? "light" : "dark");
        },

        login: function () {
            this.$requireLogin();
        },

        showNotifications: function(){
            this.$emit("toggle-notifications-menu");
        },

        clickMenu: function () {
            this.$emit("toggle-menu");
        },

        onAuthChanged: function () {
            this.loggedIn = AuthController.isAuthenticated();
            this.profileName = AuthController.ProfileName || AuthController.Username || "";
            this.profileImage = AuthController.ProfileImage;
        },

        onThemeChanged: function (t: ColorThemeName) {
            this.theme = t;
        },

        renderName: function (name: string): string {
            return ((name + "").split(" ")[0] + "").split(",")[0] || "???";
        },
    },
    mounted: function () {
        this.$listenOnAppEvent("auth-status-changed", this.onAuthChanged.bind(this));
        this.$listenOnAppEvent("theme-changed", this.onThemeChanged.bind(this));
    },
    beforeUnmount: function () {},
});
</script>

<style scoped>
.logo-img {
    object-fit: contain;
    width: 170px;
    padding-top: 11px;
    margin-left: 10px;
}
.top-bar-notifications{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.dark-theme .logo-img {
    filter: brightness(0) invert(1);
}
.inner-top-bar{
    display: flex;
    margin-right: 5px;
}
.btn-top-bar-login{
    padding: 10px 15px;
}
.btn-top-bar-login i{
    margin-right: 0;
}
.btn-top-bar-notifictions{
    color: initial !important;
    border: 0 !important;
    box-shadow: none !important;
    margin-right: 15px;
    border-radius: 50%;
    height: 47px;
    padding: 7px;
    width: 50px;
}
.btn-top-bar-notifictions i{
    font-size: 18px;
    margin-right: 0;
    color: #fff;
}
.num-notifications{
    font-weight: bold;
    color: #fff;
    font-size: 12px;
    margin-left: 4px;
}
.top-bar-button-img {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
}

@media (max-width: 639px) {
    .logo-img{
        width: 100px;
    }
    .btn-top-bar-notifictions i{
        font-size: 18px;
    }
}
@media (max-width: 450px) {
    .logo-img{
        padding-top: 8px;
        padding-right: 10px;
    }
    .btn-top-bar-login{
        padding: 8px 10px !important;
    }

}
</style>
